import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy, arrayMove } from '@dnd-kit/sortable';
import Grid from '@mui/material/Grid';
import { ImageContainer } from '../ImageContainer';
import { ESize, IEntryData, IPhotoFile } from 'models/galery';

interface ISortableImages {
  fields: any;
  getValues: any;
  replace: any;
  move: any;
  files: IPhotoFile;
  longDateFormat: string;
  control: any;
  errors: any;
  setValue: any;
  handleDelete: (id: string) => void;
  handleFullSize: (position: number) => void;
  withLinkedLicences: boolean;
  sizeImage: ESize;
  sizeFullImage: ESize;
  entryWarnings: Record<string, string[]>;
}

const SortableImages = ({
  fields,
  getValues,
  replace,
  move,
  files,
  longDateFormat,
  control,
  errors,
  setValue,
  handleDelete,
  handleFullSize,
  withLinkedLicences,
  sizeImage,
  sizeFullImage,
  entryWarnings,
}: ISortableImages) => {
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const oldIndex = fields.findIndex((f: { uniqueId: string }) => f.uniqueId === active.id);
    const newIndex = fields.findIndex((f: { uniqueId: string }) => f.uniqueId === over.id);

    move(oldIndex, newIndex);

    const updated = getValues('entryParameters').map((item: any, index: any) => ({
      ...item,
      position: index,
    }));

    replace(updated);
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext
        items={fields.map((p: IEntryData) => p.uniqueId)}
        strategy={rectSortingStrategy}
      >
        <Grid container sx={{ gap: '20px' }}>
          {fields.map((data: IEntryData, index: number) => (
            <ImageContainer
              key={data.uniqueId}
              id={data.uniqueId}
              data={data}
              image={files[data.uniqueId]}
              index={index}
              handleFullSize={() => handleFullSize(Number(data.position))}
              handleDelete={() => handleDelete(data.uniqueId)}
              dateFormat={longDateFormat}
              control={control}
              errors={errors}
              setValue={setValue}
              withLinkedLicences={withLinkedLicences}
              sizeImage={sizeImage}
              sizeFullImage={sizeFullImage}
              warnings={entryWarnings[data.uniqueId]}
            />
          ))}
        </Grid>
      </SortableContext>
    </DndContext>
  );
};

export default SortableImages;
